/* unplugin-vue-components disabled */import script from "./amazonAuCalculator.vue?vue&type=script&setup=true&lang=js"
export * from "./amazonAuCalculator.vue?vue&type=script&setup=true&lang=js"

import "./amazonAuCalculator.vue?vue&type=style&index=0&id=02336335&lang=css"

const __exports__ = script;

export default __exports__